import * as yup from "yup";

import { STATES } from "../../../constants/states";

export const A5_COMPLETE_INITIAL_VALUES = {
  address: {
    city: "",
    state: "",
    street: "",
    zip_code: "",
  },
  email: "",
  email_validation: "",
  mobile: "",
  pcp_name: "",
};

export const A5_COMPLETE_SCHEMA = [
  {
    elementConfig: {
      label: "Email",
      placeholder: "Email",
      type: "email",
    },
    elementType: "input",
    name: "email",
  },
  {
    elementConfig: {
      label: "Re-Enter Email",
      placeholder: "Email",
      type: "email",
    },
    elementType: "input",
    name: "email_validation",
  },
  {
    elementConfig: {
      label: "Mobile",
      placeholder: "Mobile",
      type: "text",
    },
    elementType: "input",
    name: "mobile",
  },
  {
    elementConfig: {
      label: "Street Address",
      placeholder: "Enter Street",
      type: "text",
    },
    elementType: "input",
    name: "address.street",
  },
  {
    elementConfig: {
      label: "City",
      placeholder: "Enter City",
      type: "text",
    },
    elementType: "input",
    name: "address.city",
  },
  {
    elementConfig: {
      label: "State",
      options: STATES,
      placeholder: "Enter State",
    },
    elementType: "select",
    name: "address.state",
  },
  {
    elementConfig: {
      label: "Zip",
      placeholder: "Enter zip",
      type: "text",
    },
    elementType: "input",
    name: "address.zip_code",
  },
  {
    elementConfig: {
      label: "Your physician",
      options: [],
      placeholder: "Your physician",
    },
    elementType: "select",
    name: "pcp_name",
  },
];

export const A5_COMPLETED_VALIDATION = yup.object().shape({
  address: yup.object().shape({
    city: yup.string().required("City is required"),
    state: yup.string().required("State is required"),
    street: yup.string().required("Street is required"),
    zip_code: yup.string().required("Zip Code is required"),
  }),
  email: yup.string().email("Enter a valid email address").required("Email is required"),
  email_validation: yup
    .string()
    .email("Enter a valid email address")
    .required("Email is required")
    .test("email-match", "Address Do Not Match. Please Check Email Spelling", function (value) {
      if (!value) {
        return false;
      }

      return this.parent.email === value;
    }),
  mobile: yup
    .string()
    .matches(/^\d{10}$/, "Contact Number must be a valid US number")
    .required("Mobile no. is required"),
  pcp_name: yup.string().required("PCP Name is required"),
});
